var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass,on:{"click":_vm.toSubscriptionPage}},[_vm._t("default",[_vm._v("\n      サブスクで購入\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }